var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link as RouterLink } from "react-router-dom";
import { Card, CardContent, Box, Typography, Button, Avatar, Grid, } from "@mui/material";
import { Add, Assignment, BarChart, ListAlt, ListAltOutlined, Visibility, } from "@mui/icons-material";
var homeSections = [
    {
        title: "Criação de formulários",
        description: "Elabore formulários de assuntos gerais ou de pesquisas de satisfação.",
        variant: "create",
        cards: [
            {
                title: "Forms Designer",
                description: "Criação de formulários gerais.",
                path: "/forms",
                icon: _jsx(Assignment, {}),
            },
            {
                title: "NPS Designer",
                description: "Criação de formulários NPS.",
                path: "/nps",
                icon: _jsx(BarChart, {}),
            },
        ],
    },
    {
        title: "Listagem e gestão",
        description: "Visualize, edite e acompanhe os formulários já cadastrados.",
        variant: "list",
        cards: [
            {
                title: "Lista de Formulários Gerais",
                description: "Visualize e gerencie todos os formulários cadastrados.",
                path: "/forms/list",
                icon: _jsx(ListAlt, {}),
            },
            {
                title: "Lista de Formulários NPS",
                description: "Acompanhe e gerencie suas pesquisas de satisfação.",
                path: "/nps/list",
                icon: _jsx(ListAltOutlined, {}),
            },
        ],
    },
];
var cardPalette = {
    create: {
        avatar: "#2e7d32",
        button: "#2e7d32",
        buttonHover: "#1b5e20",
    },
    list: {
        avatar: "#1581d0",
        button: "#0c6dbf",
        buttonHover: "#0a5ba3",
    },
};
var Home = function () {
    return (_jsxs(Box, __assign({ sx: { maxWidth: "1520px", margin: "0 auto", py: 4, px: { xs: 2, md: 4 } } }, { children: [_jsx(Typography, __assign({ variant: "h5", fontWeight: 500, gutterBottom: true }, { children: "Central de navega\u00E7\u00E3o" })), _jsx(Typography, __assign({ variant: "body2", color: "text.secondary", mb: 4 }, { children: "Selecione um m\u00F3dulo para continuar." })), _jsx(Box, __assign({ sx: { display: "flex", flexDirection: "column", gap: 4 } }, { children: homeSections.map(function (section) {
                    var sectionVariant = section.variant;
                    var accentColor = cardPalette[sectionVariant].avatar;
                    return (_jsxs(Box, __assign({ sx: function (theme) { return ({
                            p: { xs: 2, md: 3 },
                            borderRadius: 2,
                            border: "1px solid ".concat(theme.palette.divider),
                            borderTopWidth: 4,
                            borderTopColor: accentColor,
                            bgcolor: theme.palette.grey[50],
                        }); } }, { children: [_jsx(Typography, __assign({ variant: "h6", fontWeight: 600, gutterBottom: true }, { children: section.title })), _jsx(Typography, __assign({ variant: "body2", color: "text.secondary", mb: 2 }, { children: section.description })), _jsx(Grid, __assign({ container: true, spacing: 1.5 }, { children: section.cards.map(function (route) {
                                    var palette = cardPalette[section.variant];
                                    return (_jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsx(Card, __assign({ elevation: 1, sx: { borderRadius: 2 } }, { children: _jsxs(CardContent, { children: [_jsxs(Box, __assign({ sx: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 2,
                                                        } }, { children: [_jsx(Avatar, __assign({ sx: {
                                                                    bgcolor: palette.avatar,
                                                                    width: 54,
                                                                    height: 54,
                                                                } }, { children: route.icon })), _jsxs(Box, __assign({ sx: { flex: 1 } }, { children: [_jsx(Typography, __assign({ variant: "h5", fontWeight: 600 }, { children: route.title })), _jsx(Typography, __assign({ variant: "body1", color: "text.secondary" }, { children: route.description }))] }))] })), _jsx(Button, __assign({ fullWidth: true, variant: "contained", size: "medium", sx: {
                                                            mt: 2,
                                                            borderRadius: "10px",
                                                            backgroundColor: palette.button,
                                                            "&:hover": {
                                                                backgroundColor: palette.buttonHover,
                                                            },
                                                        }, component: RouterLink, to: route.path }, { children: section.variant === "create" ? (_jsxs(_Fragment, { children: [_jsx(Add, { sx: { mr: 1 } }), "CRIAR"] })) : (_jsxs(_Fragment, { children: [_jsx(Visibility, { sx: { mr: 1 } }), "ACESSAR"] })) }))] }) })) }), route.path));
                                }) }))] }), section.title));
                }) }))] })));
};
export default Home;
